import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import LegalLayout from "../components/LegalLayout";
import useSeo from "../hooks/useSeo";

export default function Privacy() {
  useSeo("Privacy Policy | SimplySitter", "How SimplySitter, a brand of Elite Swiss LLC, collects, uses and protects your personal information.");

  return (
    <div>
      <Header />
      <LegalLayout title="Privacy Policy" testid="privacy-page">
        <p>This Privacy Policy explains how SimplySitter, a brand of Elite Swiss LLC, collects, uses and protects the information you share with us when you use simplysitter.us (the "Service").</p>

        <h2>1. Who we are</h2>
        <p>The Service is operated by Elite Swiss LLC, 7255 Bee Ridge Road, Sarasota, FL 34245, United States. SimplySitter is a brand of Elite Swiss LLC. If you have questions about this policy, contact us at <a href="mailto:hello@simplysitter.us">hello@simplysitter.us</a>.</p>

        <h2>2. Information we collect</h2>
        <p>We collect information you provide directly, such as your name, email address, phone number, location, job details, caregiver profile, resume and identification documents. We also collect limited technical data (such as your device and usage information) to keep the Service secure and running.</p>

        <h2>3. How we use your information</h2>
        <p>We use your information to create and manage your account, match families with vetted caregivers, verify caregiver identities, process payments, send service-related notifications and improve the Service. We do not sell your personal information.</p>

        <h2>4. Sharing your information</h2>
        <p>Caregiver profiles, resumes and identity documents are shared with a family only after that caregiver has applied to the family's job. We share data with trusted service providers (for example payment and email providers) solely to operate the Service, and when required by law.</p>

        <h2>5. Payments</h2>
        <p>Payments are processed securely by Stripe. We do not store your full card details on our servers.</p>

        <h2>6. Data retention and security</h2>
        <p>We keep your information for as long as your account is active or as needed to provide the Service and meet legal obligations. We use reasonable technical and organizational measures to protect your data.</p>

        <h2>7. Your rights</h2>
        <p>You may request access to, correction of, or deletion of your personal information by contacting us at <a href="mailto:hello@simplysitter.us">hello@simplysitter.us</a>. You can also close your account at any time.</p>

        <h2>8. Changes to this policy</h2>
        <p>We may update this Privacy Policy from time to time. We will post the updated version on this page with a revised effective date.</p>

        <div className="mt-10 rounded-2xl border border-black/10 bg-[#fdfaf7] p-5 text-[14px] text-[#5a5254]">
          <p className="font-medium text-[#1f1a1b]">Elite Swiss LLC</p>
          <p>7255 Bee Ridge Road, Sarasota, FL 34245, United States</p>
          <p className="mt-1">SimplySitter is a brand of Elite Swiss LLC.</p>
        </div>
      </LegalLayout>
      <Footer />
    </div>
  );
}
